(function () {

    var headerHeight = 0;
    var activeId = "";

    function calcHeaderHeight() {
        if (!$(".header__title").is(":visible")) {
            headerHeight = $(".header").outerHeight(true);
        } else {
            headerHeight = $(".header__top").outerHeight(true) +
                $(".header__title").outerHeight(true);
        }
    }

    function scrollActiveLink() {
        var scrollTop = $(window).scrollTop();

        calcHeaderHeight();

        $(".header a").removeClass("is-active");
        $(".accordion-xlg > .card").each(function () {
            if ($(this).attr("id") !== "" && scrollTop >= $(this).offset().top - headerHeight - 1) {
                activeId = $(this).attr("id");
            }
        });

        if (typeof activeId !== "undefined") {
            $("a[href='#" + activeId + "']").addClass("is-active");
        }
    }

    $(window).on("scroll", function () {
        scrollActiveLink();
    });

})();